import { FC } from 'react';

import LoadingSpinner from 'components/LoadingSpinner';

import { SpinnerSizes } from 'constants/enums';

import styles from './LoadingState.module.scss';

interface LoadingStateProps {
  title: string;
  size?: SpinnerSizes;
}

const LoadingState: FC<LoadingStateProps> = ({
  title,
  size = SpinnerSizes.Medium
}) => {
  return (
    <>
      <h2 className={styles.title}>{title}</h2>
      <LoadingSpinner size={size} />
    </>
  );
};

export default LoadingState;
